import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const Facts = ({
  facts: {
    customerStory: { businessFacts },
  },
}) => {
  return (
    <div className="post-single__facts">
      <h2>Business Facts</h2>
      {parse(businessFacts)}
    </div>
  );
};

Facts.propTypes = {
  facts: PropTypes.shape({
    customerStory: PropTypes.shape({
      businessFacts: PropTypes.string,
    }),
  }).isRequired,
};

export default Facts;
